//dependencies
import React from "react";

import FilterChips from "../../../../../../../components/FilterChips";
import { Filter } from "../../../../../../../components/FilterChips/FilterChips";

//components
import { FormsIDidFilters, FormsIDidStatusOptions } from "../FormsIDidFilterPanel";

const convertFiltersToReadableList = (filters?: FormsIDidFilters) => {
	const readableList: Filter[] = [];

	// Process subject filter
	if (
		filters?.subject &&
		typeof filters.subject === "object" &&
		"id" in filters.subject &&
		"name" in filters.subject
	) {
		readableList.push({
			id: "subject",
			type: "single-employee",
			label: "Subject",
			value: { name: filters.subject.name, id: filters.subject.id },
		});
	}

	// Always show status chip, defaulting to "any" if not set
	const statusValue = filters?.status || "any";
	const statusLabel = FormsIDidStatusOptions.find((option) => option.value === statusValue)?.label || "Any";
	readableList.push({
		id: "status",
		type: "string",
		label: "Status",
		value: statusLabel,
	});

	return readableList;
};

type FormsIDidReadableFiltersListProps = {
	filters: FormsIDidFilters;
	setFilters: (newFilters) => void;
};

const FormsIDidReadableFilters = ({ filters, setFilters }: FormsIDidReadableFiltersListProps) => {
	const convertedFilters = convertFiltersToReadableList(filters);

	// Make status chip non-dismissible when status is "any"
	const statusValue = filters?.status || "any";
	const nonDismissibleFilters = statusValue === "any" ? ["status"] : [];

	return (
		<FilterChips
			filters={convertedFilters}
			label="Filters applied: "
			nonDismissibleFilters={nonDismissibleFilters}
			onDeleteFilter={(id) => {
				const newFilters = { ...filters };
				if (id === "status") {
					// Reset status to "any" instead of deleting
					newFilters.status = "any";
				} else {
					newFilters[id] = undefined;
				}
				setFilters(newFilters);
			}}
		/>
	);
};

export default FormsIDidReadableFilters;
